/**
 * Validates whether a given URL is valid.
 *
 * @param url - The URL string to be validated.
 * @returns The trimmed URL string if valid, false otherwise.
 * TODO: trim only removes leading and trailing whitespace, but regex does not allow spaces in the URL, so if want to allow spaces in the URL, need to modify the regex; if not, can remove the trim.
 */
const validateURL = (url: any) => {
  const urlPattern = /^(http[s]?:\/\/)(www\.)?[^\s$.?#].[^\s]*$/;
  return urlPattern.test(url) && url.trim()
};

export {
  validateURL
}